import React from 'react';

/**
 * The sidenav lets users navigate through subsets of data pertaining to a resource.
 * It can be nested under the page header navigation, as secondary navigation.
 *
 * The expected structure of a `Sidenav` is:
 * `<Sidenav> <SidenavSection> <SidenavItem /> </SidenavSection> </Sidenav>`
 *
 * Please refer to each component's documentation for more information on how to use them.
 */
function Sidenav({ children, label, selectedItemLabel, className, popoverId, }) {
    const popoverIdProp = popoverId && popoverId.trim() ? { "popover-id": popoverId } : {};
    return (React.createElement("tds-sidenav", { label: label, "selected-item-label": selectedItemLabel, class: className, ...popoverIdProp }, children));
}

export { Sidenav };
//# sourceMappingURL=Sidenav.js.map
